export default __webpack_public_path__ + "static/media/programmer.becd1465.svg";